import React from 'react';

import Header from './Header';
import PageValueSet from './ValueSet/PageValueSet';
import PageCodeSystem from './CodeSystem/PageCodeSystem';
import HomePage from './HomePage';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PageRefSets from './RefSets/PageRefSets';
import GlobalContextProvider from './contexts/GlobalContext';
import './App.css';

function App() {

	return (
		<Router>
			<div className="app">
				<GlobalContextProvider>
					<Header />
					<Switch>
						<Route path="/CodeSystem" component={PageCodeSystem} />
						<Route path="/ValueSet" component={PageValueSet} />
						<Route path="/RefSets" component={PageRefSets} />
						{/* <Route path="/ConceptMaps" component={HomePage} />
						<Route path="/NamingSystems" component={HomePage} /> */}
						<Route path="/" exact component={HomePage} />
					</Switch>
				</GlobalContextProvider>
			</div>
		</Router>
	);
}

export default App;
